import iziToast from 'izitoast'

export const ajaxManagerConfig = async () => {
    await $store.dispatch('ajaxManager/setService', [
        {
            name: 'AMS',
            config: {
                url: process.env.VUE_APP_AMS_SERVICE_URL,
                port: process.env.VUE_APP_AMS_SERVICE_PORT,
                apiVer: null,
                token: ''
            }
        },
        {
            name: 'backend-service',
            config: {
                url: process.env.VUE_APP_VOIP_GENERAL_BACKEND_SERVICE_URL,
                port: process.env.VUE_APP_VOIP_GENERAL_BACKEND_SERVICE_PORT,
                /*url: 'http://127.6.1.1',
                port: '8000',*/
                apiVer: null,
                token: ''
            }
        },
        {
            name: 'voip-fusion-call-service',
            config: {
                url: process.env.VUE_APP_VOIP_FUSION_CALL_SERVICE_URL,
                port: process.env.VUE_APP_VOIP_FUSION_CALL_SERVICE_PORT,
                /*url: 'http://127.9.1.2',
                port: '8000',*/
                apiVer: null,
                token: ''
            }
        },
        {
            name: 'voip-cdr-service',
            config: {
                url: process.env.VUE_APP_VOIP_CDR_SERVICE_URL,
                port: process.env.VUE_APP_VOIP_CDR_SERVICE_PORT,
                /*url: 'http://127.9.1.3',
                port: '8000',*/
                apiVer: null,
                token: ''
            }
        }
    ])
    await $store.dispatch('ajaxManager/setErrorHandler', (error) => {
        if (error.response) {
            let errorCode = error.response.status
            if (errorCode === 401) {

                if (!localStorage.getItem('redirected_to_login')) {
                    iziToast.warning({
                        title: 'Caution',
                        message: 'You have to check your credentials',
                        position: 'center',
                        timeout: 1000,
                        animateInside: true,
                        close: false,
                        onClosed: () => {
                            localStorage.setItem('redirected_to_login', 1)
                            $router.push({ name: 'module->user->logout'})
                        }
                    });
                }

            }
        } else {
         console.log('ajax manager Error Handler', error)
        }
    })
}
